const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/trash/getters.js